import React from 'react';
import { Form } from 'react-bootstrap';
import ListIcon1 from "../../../images/calender-icon.svg";
import ListIcon2 from "../../../images/calender-icon.svg";
import ListIcon3 from "../../../images/note-icon-2.svg";
import ListIcon4 from "../../../images/calender-icon.svg";
import ListIcon5 from "../../../images/calender-icon.svg";
import ListIcon6 from "../../../images/status-icon.svg";
import ListIcon7 from "../../../images/subscribe-icon.svg";
import ListIcon8 from "../../../images/promo-icon.svg";
import ListIcon9 from "../../../images/card-icon.svg";
import ListIcon10 from "../../../images/amount-icon.svg";
import ListIcon11 from "../../../images/discount-icon.svg";

interface SubscriptionTabProps {
  userData: any;
}

const SubscriptionTab: React.FC<SubscriptionTabProps> = ({ userData }) => {
  // Format date helper - handles MM/dd/yyyy format from API
  const formatDate = (dateString: string): string => {
    if (!dateString) return 'N/A';
    try {
      // If it's already in MM/dd/yyyy format, return as is
      if (dateString.includes('/')) {
        return dateString;
      }
      // Otherwise try to parse as ISO date
      return new Date(dateString).toLocaleDateString('en-US', {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit'
      });
    } catch {
      return dateString;
    }
  };

  // Format datetime helper
  const formatDateTime = (dateString: string): string => {
    if (!dateString) return 'N/A';
    try {
      // If it's already in formatted format, return as is
      if (dateString.includes('/') && dateString.includes(':')) {
        return dateString;
      }
      // If it's already in d-m-yyyy h:mm AM/PM format, return as is
      if (dateString.includes('-') && (dateString.includes('AM') || dateString.includes('PM'))) {
        return dateString;
      }
      // Otherwise try to parse as full datetime
      return new Date(dateString).toLocaleString('en-US', {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
        hour12: true
      });
    } catch {
      return dateString;
    }
  };

  // Format status to display with proper capitalization
  const formatStatus = (status: string | undefined | null): string => {
    if (!status) return "Not subscribed";

    // Capitalize first letter and make rest lowercase
    return status.charAt(0).toUpperCase() + status.slice(1).toLowerCase();
  };

  // Capitalize text helper
  const capitalizeText = (text: string) => {
    if (!text) return '';
    return text
      .split(' ')
      .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
      .join(' ');
  };

  return (
    <div className="tab-pane-content billing-tab">
      <div className='billing-list'>
        <div className='row'>
          <ul>
            <li>
              <span>
                <img src={ListIcon1} alt='Calendar' />
              </span>
              <p>Registration Date: <strong>{formatDate(userData?.registrationDate)}</strong></p>
            </li>
            <li>
              <span>
                <img src={ListIcon2} alt='Calendar' />
              </span>
              <p>Last Activity: <strong>{formatDateTime(userData?.lastActive)}</strong></p>
            </li>
            <li>
              <span>
                <img src={ListIcon3} alt='Note' />
              </span>
              <p>Plan Type: <strong>{capitalizeText(userData?.subscriptionType) || 'Not subscribed'}</strong></p>
            </li>
            <li>
              <span>
                <img src={ListIcon4} alt='Calendar' />
              </span>
              <p>Start Date: <strong>{formatDate(userData?.startDate || '')}</strong></p>
            </li>
            <li>
              <span>
                <img src={ListIcon5} alt='Calendar' />
              </span>
              <p>End Date: <strong>{formatDate(userData?.endDate || '')}</strong></p>
            </li>
            <li>
              <span>
                <img src={ListIcon6} alt='Status' />
              </span>
              <p>Status: <strong>{formatStatus(userData?.subscriptionStatus)}</strong></p>
            </li>
            <li>
              <span>
                <img src={ListIcon7} alt='Subscribe' />
              </span>
              <p>Subscription: <strong>{capitalizeText(userData?.subscriptionName) || 'Not subscribed'}</strong></p>
            </li>
            <li>
              <span>
                <img src={ListIcon8} alt='Promo' />
              </span>
              <p>Promo Code: <strong>{userData?.promoCode || 'N/A'}</strong></p>
            </li>
            <li>
              <span>
                <img src={ListIcon9} alt='Card' />
              </span>
              <p>Card Type: <strong>{userData?.cardType || 'N/A'}</strong></p>
            </li>
            <li>
              <span>
                <img src={ListIcon10} alt='Amount' />
              </span>
              <p>Amount: <strong>${userData?.amount || 0}</strong></p>
            </li>
            <li>
              <span>
                <img src={ListIcon11} alt='Discount' />
              </span>
              <p>Discount: <strong>${userData?.discount || 0}</strong></p>
            </li>
          </ul>
          {/* <ul className='col-xl-4 col-lg-6 col-md-6 col-md-12 mb-3'>
            <li>
              <span>
                <img src={ListIcon7} alt='Subscribe' />
              </span>
              <p>Subscription: <strong>{userData?.subscriptionName || 'Not subscribed'}</strong></p>
            </li>
            <li>
              <span>
                <img src={ListIcon8} alt='Promo' />
              </span>
              <p>Promo Code: <strong>{userData?.promoCode || 'N/A'}</strong></p>
            </li>
            <li>
              <span>
                <img src={ListIcon9} alt='Card' />
              </span>
              <p>Card Type: <strong>{userData?.cardType || 'N/A'}</strong></p>
            </li>
            <li>
              <span>
                <img src={ListIcon10} alt='Amount' />
              </span>
              <p>Amount: <strong>${userData?.amount || 0}</strong></p>
            </li>
            <li>
              <span>
                <img src={ListIcon11} alt='Discount' />
              </span>
              <p>Discount: <strong>${userData?.discount || 0}</strong></p>
            </li>
          </ul> */}
        </div>
      </div>
    </div>
  );
};

export default SubscriptionTab;